import React from "react";

// Pre-onboarding state — user has no natal chart yet.
export function NeedsNatalCard() {
  return (
    <section
      className="rounded-2xl border border-[#4A3356] bg-gradient-to-br from-[#1C1622] to-[#261E2E] p-4 sm:p-5"
      data-testid="top-cities-needs-natal"
    >
      <div className="text-[9px] uppercase tracking-[0.3em] text-[#C8A96E]">Your Three Destined Cities</div>
      <div className="font-heading text-lg sm:text-xl mt-0.5">Complete your natal chart to unlock</div>
      <p className="text-xs text-[#E8DFD3] mt-2 max-w-lg">
        Money, Love, and Healing cities are computed from your birth chart. Add your birth date, time and location to reveal them.
      </p>
      <a
        href="/onboarding"
        data-testid="top-cities-complete-natal-link"
        className="inline-block mt-3 text-[10px] uppercase tracking-widest text-[#C8A96E] border border-[#C8A96E]/60 rounded-full px-3 py-1.5 hover:bg-[#C8A96E]/10 transition-colors"
      >
        Complete Natal Chart →
      </a>
    </section>
  );
}
